<ng-template [sbmodal]="'mediaexplorermodald'">
  <sb-custom-modal [templateId]="'mediaexplorermodald'">
    <div slot="body">
      <sb-page-medium-explorer [customer]="campaignData?.customer" [isInModalContext]="'mediaexplorermodald'"
                               [modalType]="'bookingSelect'"></sb-page-medium-explorer>
    </div>
  </sb-custom-modal>
</ng-template>

<ng-template [sbmodal]="'inventorySelectionModal'">
  <sb-custom-modal [templateId]="'inventorySelectionModal'">
    <div slot="body">
      <sb-page-inventory-wrapper [isInModalContext]="true"></sb-page-inventory-wrapper>
    </div>
  </sb-custom-modal>
</ng-template>

<ng-template [sbmodal]="'filterEditModal'">
  <sb-custom-modal [templateId]="'filterEditModal'">
    <div slot="body">
      <filter-edit></filter-edit>
    </div>
  </sb-custom-modal>
</ng-template>

<ng-template [sbmodal]="'finishmodal'">
  <sb-custom-modal [templateId]="'finishmodal'">
    <div slot="body">
      <div class="d-flex justify-content-center">
        <sb-icon
          [animationOptions]="{autoplay: true, loop: false}" class="green"
          icon="successAnimation" style="font-size: 5rem"></sb-icon>
      </div>
      <div
        class="mt-4">{{ !commercialId ? ('lang.commercialEdit.createdSuccessfully' | translate) : ('lang.commercialEdit.editedSuccessfully' | translate) }}
      </div>
      <div *ngIf="showBookingsNotice() || !commercialId">{{ 'lang.globals.bookingsVerificationPending' | translate }}
      </div>
    </div>
    <div slot="footer">
      <sb-button (click)="modal.close('finishmodal')" classes="btn-secondary btn-sm text-uppercase mr-0">
        {{ 'lang.commercialEdit.okay' | translate }}
      </sb-button>
    </div>
  </sb-custom-modal>
</ng-template>

<div class="row">
  <div class="col-12">
    <sb-comp-ccr-hero [ccr]="campaignData" [isCollapsed]="true"></sb-comp-ccr-hero>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <ng-template #tab1Headline>
          <ng-container
            *ngIf="commercialData?.name && commercialData?.duration && commercialData?.from && commercialData?.till">
            <div style="font-size: .9rem;">
              <div class="font-weight-bold my-2">
                <span [innerHTML]="commercialData.name | truncate : 20"></span>
              </div>
              <div class="font-weight-bold my-2">
                {{ commercialData.duration }}s
              </div>
              <div class="font-weight-bold my-2">
                {{ commercialData.from?.toString() | date: 'dd.MM.yy HH:mm' }}
                - {{ commercialData.till?.toString() | date: 'dd.MM.yy HH:mm' }}
              </div>
            </div>
          </ng-container>
        </ng-template>
        <sb-wizard #wizard [clickableTabs]="false" classes="wizard__minHeightSetting">
          <sb-wizard-tab #tab1 [disabled]="wizardState!=='Map'" [headlineTemplate]="tab1Headline"
                         icon="basicSettings" titleText="{{ 'lang.wizard.tabs.settings' | translate }}">
            <form [formGroup]="form" class="wizard__forms px-5 pb-5">
              <h3 class="mb-4">{{ 'lang.commercialEdit.settingsHeadline' | translate }}</h3>
              <div class="row">
                <div class="col-6">
                  <div class="form-group validateMe d-block">
                    <label class="form-label" for="Title">{{ 'lang.commercialEdit.title' | translate }}<span class="red">*</span></label>
                    <div class="d-flex">
                      <input class="form-control mr-1" formControlName="Title" id="Title" sbAutofocus type="text">
                      <button (click)="getNameFromMotive($event)" [openDelay]="500"
                              class="btn btn-hover-primary" container="body" ngbTooltip="{{'lang.globals.getNameFromMotive' | translate}}"
                              type="button">
                        <sb-icon icon="password"></sb-icon>
                      </button>
                    </div>
                    <span class="form-text text-muted">{{ 'lang.commercialEdit.titleDescription' | translate }}</span>
                    <div *ngIf="Title.dirty && Title.errors?.required" class="alert alert-danger">
                      {{ 'lang.commercialEdit.titleWarning' | translate }}
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group validateMe d-block">
                    <label class="form-label" for="Duration">{{ 'lang.commercialEdit.duration' | translate }}<span
                      class="red">*</span></label>
                    <div class="d-flex">
                      <input class="form-control mr-1" formControlName="Duration" id="Duration" min="1" type="number">
                      <button (click)="getDurationFromMotive($event)" [openDelay]="500"
                              class="btn btn-hover-primary" container="body"
                              ngbTooltip="{{'lang.globals.getDurationFromMotive' | translate}}"
                              type="button">
                        <sb-icon icon="clock"></sb-icon>
                      </button>
                    </div>
                    <span class="form-text text-muted">{{ 'lang.commercialEdit.durationDescription' | translate }}</span>
                    <div *ngIf="Duration.dirty && Duration.errors?.required" class="alert alert-danger">
                      {{ 'lang.commercialEdit.durationWarning' | translate }}
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group validateMe d-block">
                    <label class="form-label" for="Frequency">{{ 'lang.commercialEdit.frequency' | translate }}<span
                      class="red">*</span></label>
                    <div class="d-flex">
                      <input class="form-control mr-1" formControlName="Frequency" id="Frequency" max="300" min="1"
                             type="number">
                    </div>
                    <span class="form-text text-muted">{{ 'lang.commercialEdit.frequencyDescription' | translate }}</span>
                    <div *ngIf="Frequency.dirty && Frequency.errors?.required" class="alert alert-danger">
                      {{ 'lang.commercialEdit.frequencyWarning' | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-xl-6">
                  <div class="form-group validateMe d-block">
                    <label class="form-label" for="Identifier">{{ 'lang.globals.identifier' | translate }}</label>
                    <div class="d-flex">
                      <input class="form-control mr-1" formControlName="Identifier" id="Identifier" type="text">
                    </div>
                    <span class="form-text text-muted">{{ 'lang.globals.identifierDescription' | translate }}</span>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="form-group validateMe d-block">
                    <label class="form-label" for="Description">{{ 'lang.globals.description' | translate }}</label>
                    <div class="d-flex">
                      <input class="form-control mr-1" formControlName="Description" id="Description" type="text">
                    </div>
                    <span class="form-text text-muted">{{ 'lang.globals.descriptionDescription' | translate }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-xl-6">
                  <div class="form-group">
                    <sb-local-date-time-input (modelChange)="localDateTimeInputFrom($event)" [inputRequired]="true" [kind]="'RANGE_START'"
                                              [seconds]="false"
                                              [title]="translate.instant('lang.globals.startTime')" class="w-100"
                                              formControlName="From"
                                              id="From">
                    </sb-local-date-time-input>
                    <span class="form-text text-muted">{{ 'lang.commercialEdit.startTimeDescription' | translate }}</span>
                    <div *ngIf="From.dirty && From.errors?.required" class="alert alert-danger">
                      {{ 'lang.commercialEdit.startTimeWarning' | translate }}
                    </div>
                    <div *ngIf="form.dirty && form.errors?.endDateAfterStartDate" class="alert alert-danger">
                      {{ 'lang.commercialEdit.startTimeCorrection' | translate }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="form-group">
                    <sb-local-date-time-input (modelChange)="localDateTimeInputTill($event)" [inputRequired]="true" [kind]="'RANGE_END'"
                                              [minDate]="From.value"
                                              [seconds]="false" [title]="translate.instant('lang.globals.dueTime')"
                                              class="w-100"
                                              formControlName="Till"
                                              id="Till"></sb-local-date-time-input>
                    <span class="form-text text-muted">{{ 'lang.commercialEdit.dueTimeDescription' | translate }}</span>
                    <div *ngIf="Till.dirty && Till.errors?.required" class="alert alert-danger">
                      {{ 'lang.commercialEdit.dueTimeWarning' | translate }}
                    </div>
                    <div *ngIf="form.dirty && form.errors?.endDateAfterStartDate" class="alert alert-danger">
                      {{ 'lang.commercialEdit.dueTimeCorrection' | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard__footerActions">
                <sb-button
                  (click)="util.returnToNavigation(util.RoutingID.commercials, {id: 'campaignID', value: campaignId})"
                  classes="btn-default btn-wizard"
                  type="button">{{ 'lang.globals.cancel' | translate }}
                </sb-button>
                <button (click)="nextStep(wizard, tab2)" [disabled]="!form.valid" class="btn btn-primary btn-wizard"
                        type="button">{{ 'lang.globals.next' | translate }}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
          <sb-wizard-tab #tab2 icon="selection" titleText="{{ 'lang.wizard.tabs.selection' | translate }}">
            <div class="wizard__forms px-5">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <h3>{{ 'lang.commercialEdit.selectionSettings' | translate }} </h3>
                <h6>
                  <sb-icon icon="location"></sb-icon>
                  {{ previewCommercialData?.playerAggregation?.locations | sbNumberFormat }}
                  {{ 'lang.globals.locations' | translate }} /
                  <sb-icon icon="screen"></sb-icon>
                  {{ previewCommercialData?.playerAggregation?.screens | sbNumberFormat }}
                  {{ 'lang.globals.player' | translate }}
                </h6>
              </div>
              <div *ngPermissions="[permissionService.Permission.cull_show]" class="wizard__forms__filterWrapper">

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizard__forms__filterWrapper__filterStep__singleFilter__headline">
                    <h6>{{ 'lang.globals.campaignFilter' | translate }}</h6>
                  </div>
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizard__forms__filterWrapper__filterStep__singleFilter__headline">
                    <h6>{{ 'lang.globals.commercialFilter' | translate }}</h6>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : campaignData?.timeCull}" icon="calendar"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="campaignData?.timeCull?.name"
                          [innerHTML]="campaignData?.timeCull?.name | truncate : 7"
                          style="margin: 0 0 0 1rem;"></h3>
                    </div>
                  </div>
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('TimeCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : commercialData?.timeCull}" icon="calendar"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="commercialData?.timeCull?.name">{{ commercialData?.timeCull?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.timeFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button (click)="changeWizardState('TimeCullSelect')"
                                 *ngPermissions="[permissionService.Permission.cull_list]"
                                 classes="btn-hover-primary m-0 green {{wizardState==='TimeCullSelect' ? 'btn-hover-primary--active' : ''}}"
                                 container="body"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate}}" placement="top">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        (click)="changeWizardState('TimeCullEdit')"
                        *ngIf="!commercialData?.timeCull && permissionService.hasPermissions([permissionService.Permission.cull_time_create])"
                        classes="btn-hover-primary m-0 green {{wizardState==='TimeCullEdit' ? 'btn-hover-primary--active' : ''}}"
                        container="body"
                        ngbTooltip="{{'lang.globals.createFilter' | translate}}" placement="top">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        (click)="changeWizardState('TimeCullEdit')"
                        *ngIf="commercialData?.timeCull && !commercialData?.timeCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_time_edit])"
                        classes="btn-hover-primary {{wizardState==='TimeCullEdit' ? 'btn-hover-primary--active' : ''}}"
                        container="body"
                        ngbTooltip="{{'lang.globals.editSelectedFilter' | translate}}" placement="top">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button (click)="sliceCull($event, 'TimeCull')" *ngIf="commercialData?.timeCull"
                                 classes="btn-danger m-0"
                                 container="body"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate}}" placement="top">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : campaignData?.playerCull}" icon="playerOnline"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="campaignData?.playerCull?.name"
                          [innerHTML]="campaignData?.playerCull?.name | truncate : 7"
                          style="margin: 0 0 0 1rem;"></h3>
                    </div>
                  </div>
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('PlayerCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : commercialData?.playerCull}" icon="playerOnline"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="commercialData?.playerCull?.name">{{ commercialData?.playerCull?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.playerFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button (click)="changeWizardState('PlayerCullSelect')"
                                 *ngPermissions="[permissionService.Permission.cull_list]"
                                 classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullSelect' ? 'btn-hover-primary--active' : ''}}"
                                 container="body"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate}}" placement="top">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span *ngIf="!commercialData?.playerCull" class="btn-separator">|</span>
                      <sb-button
                        (click)="changeWizardState('PlayerCullEdit')"
                        *ngIf="!commercialData?.playerCull && permissionService.hasPermissions([permissionService.Permission.cull_player_create])"
                        classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}"
                        container="body"
                        ngbTooltip="{{'lang.globals.createFilter' | translate}}" placement="top">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        (click)="openInventoryView()"
                        *ngIf="!commercialData?.playerCull && permissionService.hasPermissions([permissionService.Permission.cull_player_create])"
                        classes="btn-hover-primary m-0 green"
                        container="body"
                        ngbTooltip="{{'lang.globals.selectScreens' | translate}}" placement="top">
                        <sb-icon icon="checkList"></sb-icon>
                      </sb-button>
                      <sb-button
                        (click)="changeWizardState('PlayerCullEdit')"
                        *ngIf="commercialData?.playerCull && !commercialData?.playerCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_player_edit])"
                        classes="btn-hover-primary {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}"
                        container="body"
                        ngbTooltip="{{'lang.globals.editSelectedFilter' | translate}}" placement="top">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button (click)="sliceCull($event, 'PlayerCull')" *ngIf="commercialData?.playerCull"
                                 classes="btn-danger m-0"
                                 container="body"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate}}" placement="top">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizardFilterBG">
                    <div class="wizard__forms__filterWrapper__filterStep__icon m-0">
                      <sb-icon [ngClass]="{'blue' : campaignData?.geoCull}" icon="globe"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="campaignData?.geoCull?.name"
                          [innerHTML]="campaignData?.geoCull?.name | truncate : 7"
                          style="margin: 0 0 0 1rem;"></h3>
                    </div>
                  </div>
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('GeoCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : commercialData?.geoCull}" icon="globe"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="commercialData?.geoCull?.name">{{ commercialData?.geoCull?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.geoFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button (click)="changeWizardState('GeoCullSelect')"
                                 *ngPermissions="[permissionService.Permission.cull_list]"
                                 classes="btn-hover-primary m-0 green {{wizardState==='GeoCullSelect' ? 'btn-hover-primary--active' : ''}}"
                                 container="body"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate}}" placement="top">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        (click)="changeWizardState('GeoCullEdit')"
                        *ngIf="!commercialData?.geoCull && permissionService.hasPermissions([permissionService.Permission.cull_geo_create])"
                        classes="btn-hover-primary m-0 green {{wizardState==='GeoCullEdit' ? 'btn-hover-primary--active' : ''}}"
                        container="body"
                        ngbTooltip="{{'lang.globals.createFilter' | translate}}" placement="top">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        (click)="changeWizardState('GeoCullEdit')"
                        *ngIf="commercialData?.geoCull && !commercialData?.geoCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_geo_edit])"
                        classes="btn-hover-primary {{wizardState==='GeoCullEdit' ? 'btn-hover-primary--active' : ''}}"
                        container="body"
                        ngbTooltip="{{'lang.globals.editSelectedFilter' | translate}}" placement="top">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button (click)="sliceCull($event, 'GeoCull')" *ngIf="commercialData?.geoCull"
                                 classes="btn-danger m-0"
                                 container="body"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate}}" placement="top">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

              </div>
              <div class="wizard__footerActions">
                <button (click)="nextStep(wizard, tab1)" [disabled]="wizardState!=='Map'"
                        class="btn btn-default btn-wizard"
                        container="body"
                        ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}" placement="top"
                        type="button">{{
                    'lang.globals.previous' |
                      translate
                  }}
                </button>
                <button (click)="createAndUpdateCommercial($event, wizard, tab3)" [disabled]="wizardState!=='Map' || createCommercialClick"
                        class="btn btn-primary btn-wizard"
                        container="body"
                        ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}" placement="top"
                        type="button">
                  <sb-icon *ngIf="createCommercialClick" class="mr-2" icon="loadingDotsAnimation"
                           [animationOptions]="{autoplay: true, loop:true}"></sb-icon>
                  {{ 'lang.globals.next' | translate }}
                </button>
              </div>
            </div>
          </sb-wizard-tab>
          <sb-wizard-tab #tab3 icon="bookings" titleText="{{ 'lang.wizard.tabs.bookings' | translate }}">
            <ng-container *ngIf="commercialData?.requirements?.length > 1">
              <div class="wizard__forms px-5 pb-5 text-center">
                <div>{{ 'lang.commercialEdit.bookingHint' | translate }}
                </div>
                <div class="mt-3">
                  <sb-button (click)="navigateBackToRequirementsList()" classes="btn-primary mr-0">
                    {{ 'lang.commercialEdit.requirementsList' | translate }}
                  </sb-button>
                </div>
                <div class="wizard__footerActions">
                  <button (click)="nextStep(wizard, tab2)" class="btn btn-default btn-wizard" type="button">
                    {{ 'lang.globals.previous' | translate }}
                  </button>
                  <button (click)="navigateBackToCommercialList()" class="btn btn-success btn-wizard"
                          type="button">{{ 'lang.globals.submit' | translate }}
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!(commercialData?.requirements?.length > 1)">
              <div class="wizard__forms px-5 pb-5">

                <sb-comp-requirement-booking-assignment
                  *ngIf="wizard.selectedTab === tab3"
                  (bookingsChanged)="updateBookings($event)"
                  (loadingChanged)="setLoading($event)"
                  (requirementDataChanged)="requirementDataChanged($event)"
                  [customer]="campaignData.customer"
                  [duration]="commercialData?.duration"
                  [requirementData]="requirementData">

                </sb-comp-requirement-booking-assignment>

                <div class="wizard__footerActions">
                  <button (click)="nextStep(wizard, tab2); createCommercialClick = false;" class="btn btn-default btn-wizard" type="button">
                    {{ 'lang.globals.previous' | translate }}
                  </button>
                  <button (click)="finish()" [disabled]="!requirementData?.bookings"
                          class="btn btn-success btn-wizard"
                          type="button">{{ 'lang.globals.submit' | translate }}
                  </button>
                </div>
              </div>
            </ng-container>
          </sb-wizard-tab>
          <div *ngIf="wizard.selectedTab !== tab3"
               class="wizard__aside wizard__aside--half wizard__aside--right p-0 flex-column wizardFilterBG">
            <div *ngIf="wizardState!=='Map'" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon class="icon-in-btn mr-1" icon="cancel"></sb-icon>
                {{ 'lang.globals.closeFilterSelection' | translate }}
              </button>
            </div>

            <filter-edit (submitSuccess)="filterSubmitSuccess($event)" *ngIf="wizardState==='TimeCullEdit'"
                         [cullId]="commercialData?.timeCull?.id"
                         [isInSidebarContext]=true [type]="'TimeCull'"
                         class="w-100 p-4">
            </filter-edit>

            <sb-page-filter-list (selectedFilter)="selectFilter($event)" *ngIf="wizardState==='TimeCullSelect'"
                                 [isInIntegratedContext]="true"
                                 [preselectedCompany]="campaignData?.customer" class="w-100 p-4"
                                 preselectType="TimeCull"></sb-page-filter-list>

            <filter-edit (submitSuccess)="filterSubmitSuccess($event)" *ngIf="wizardState==='PlayerCullEdit'"
                         [cullId]="commercialData?.playerCull?.id"
                         [isInSidebarContext]=true [type]="'PlayerCull'"
                         class="w-100 p-4"></filter-edit>

            <sb-page-filter-list (selectedFilter)="selectFilter($event)" *ngIf="wizardState==='PlayerCullSelect'"
                                 [isInIntegratedContext]="true"
                                 [preselectedCompany]="campaignData?.customer" class="w-100 p-4"
                                 preselectType="PlayerCull"></sb-page-filter-list>

            <filter-edit (submitSuccess)="filterSubmitSuccess($event)" *ngIf="wizardState==='GeoCullEdit'"
                         [cullId]="commercialData?.geoCull?.id"
                         [isInSidebarContext]=true [type]="'GeoCull'"
                         class="w-100 p-4">
            </filter-edit>

            <sb-page-filter-list (selectedFilter)="selectFilter($event)" *ngIf="wizardState==='GeoCullSelect'"
                                 [isInIntegratedContext]="true"
                                 [preselectedCompany]="campaignData?.customer" class="w-100 p-4"
                                 preselectType="GeoCull"></sb-page-filter-list>

            <div *ngIf="wizardState==='Map'">
              <sb-targeting-preview (changeWizardState)="changeWizardPreviewState($event)"
                                    [campaignPreviewData]="campaignData"
                                    [commercialPreviewData]="previewCommercialData"
                                    [wizardPreviewState]="wizardPreviewState"></sb-targeting-preview>
              <sb-comp-cluster-map (minMaxPointsChange)="refreshMap($event)"
                                   *ngIf="wizardPreviewState==='locationMap'"
                                   [clusters]="clusters" [mapHeight]="740" [mapZoom]=""

                                   style="width: 100%;display: block;"></sb-comp-cluster-map>
              <div *ngIf="wizardPreviewState==='locationList'" class="w-100 p-4" style="padding-top: 7rem!important;">
                <sb-page-inventory-wrapper [geoCull]="commercialData?.geoCull" [isInIntegratedContext]="true"
                                           [playerCull]="commercialData?.playerCull"></sb-page-inventory-wrapper>
              </div>
            </div>
          </div>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
